<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1 v-if="!isNew">{{ $t('common.change') }} {{ tenant.name }}</h1>
      <h1 v-else>{{ $t('add_tenant.new_tenant') }}</h1>
    </div>
    <div class="details-component__content">

      <form class="form fixed-form">

        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-260">
          <tr v-if="isSuperAdmin()" class="details-table__row"
            :class="{ 'details-table__row_error': errors.has('landlord') }">
            <td class="details-table__col details-table__col_label">
              <label for="landlord" class="form__label">{{ $t('common.landlord') }}</label>
            </td>
            <td class="details-table__col landlord__name" v-if="form.id === undefined">
              <el-select name="landlord" v-model="landlord" v-validate="'validLandlord'"
                :data-vv-as="$t('common.landlord')" v-if="landlords.items" :placeholder="$t('common.landlord')">
                <el-option v-for="landlord in landlords.items" :key="landlord.id" :label="landlord.name"
                  :value="landlord.id">
                </el-option>
              </el-select>
              <span v-else-if="landlord">{{ landlord.name }}</span>
              {{ landlord }}
              <tooltip v-show="errors.has('landlord')" class="form__validation">{{ $t('errors.landlord_field_required')
                }}</tooltip>
            </td>
            <td class="details-table__col landlord__name disabled" v-if="form.id !== undefined">
              {{ form.landlord.name || tenant.name }}
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('name') }">
            <td class="details-table__col details-table__col_label">
              <label for="name" class="form__label">{{ $t('common.tenant') }}</label>
            </td>
            <td class="details-table__col tenant__name">
              <input type="text" class="form__input" v-model.trim="form.name" id="name"
                v-validate="'required|min:3|max:255'" data-vv-as="Rentniku nimi" data-vv-validate-on="none" name="name"
                :placeholder="$t('common.tenant')" />
              <tooltip v-show="errors.has('name:required')" class="form__validation">{{ $t('errors.name_required') }}
              </tooltip>
              <tooltip v-show="errors.has('name:min')" class="form__validation">{{ $t('errors.name_min') }}</tooltip>
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('contactPerson') }">
            <td class="details-table__col details-table__col_label">
              <label for="contactPerson" class="form__label">{{ $t('add_tenant.contact_person') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.contactPerson" id="contactPerson"
                v-validate="'min:3'" data-vv-as="Kontaktisik" name="contactPerson"
                :placeholder="$t('tenant_details.contact_person')" />
              <tooltip v-show="errors.has('contactPerson:min')" class="form__validation">{{ $t('errors.name_min') }}
              </tooltip>
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('address') }">
            <td class="details-table__col details-table__col_label">
              <label for="address" class="form__label">{{ $t('common.address') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.address" id="address" v-validate
                data-vv-rules="min:3|max:255" data-vv-as="Aadress" name="address" :placeholder="$t('common.address')" />
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('regCode') }">
            <td class="details-table__col details-table__col_label">
              <label for="reg-code" class="form__label">{{ $t('tenant_details.reg_code') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.regCode" id="reg-code" v-validate
                data-vv-rules="max:255" data-vv-as="RegCode" name="regCode"
                :placeholder="$t('tenant_details.reg_code')" />
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('legalAddress') }">
            <td class="details-table__col details-table__col_label">
              <label for="legal-address" class="form__label">{{ $t('tenant_details.legal_address') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.legalAddress" id="legal-address" v-validate
                data-vv-rules="min:3|max:255" data-vv-as="LegalAadress" name="legalAddress"
                :placeholder="$t('tenant_details.legal_address')" />
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('vatNumber') }">
            <td class="details-table__col details-table__col_label">
              <label for="vat-number" class="form__label">{{ $t('tenant_details.vat_number') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.vatNumber" id="vat-number" v-validate
                data-vv-rules="max:255" data-vv-as="VatNumber" name="vatNumber"
                :placeholder="$t('tenant_details.vat_number')" />
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('phone') }">
            <td class="details-table__col details-table__col_label">
              <label for="phone" class="form__label">{{ $t('common.phone') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.phoneNumber" id="phone"
                v-validate="'validPhoneNr'" data-vv-validate-on="blur|focus" data-vv-as="Telefon" name="phone"
                :placeholder="$t('common.phone')" />
              <tooltip v-show="errors.has('phone')" class="form__validation">{{ $t('errors.phone_field') }}</tooltip>
            </td>
          </tr>
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label class="form__label">{{ $t('tenant_details.since') }}</label>
            </td>
            <td class="details-table__col">{{ form.createdAt }}</td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('email') }">
            <td class="details-table__col details-table__col_label">
              <label for="email" class="form__label">{{ $t('common.email') }}</label>
            </td>
            <td class="details-table__col">
              <input type="email" class="form__input" v-model.trim="form.email" id="email"
                v-validate="'required|email|min:3|max:255'" data-vv-as="Email" name="email" data-vv-validate-on="blur"
                :placeholder="$t('common.email')" />
              <tooltip v-show="errors.has('email')" class="form__validation">{{ $t('errors.email_field') }}</tooltip>
            </td>
          </tr>
          <tr v-if="landlord && landlord.scoroEnabled" class="details-table__row"
            :class="{ 'details-table__row_error': errors.has('scoroId') }">
            <td class="details-table__col details-table__col_label">
              <label for="scoroId" class="form__label">{{ $t('common.scoroId') }}</label>
            </td>
            <td class="details-table__col">
              <input type="text" class="form__input" v-model.trim="form.scoroId" id="scoroId" name="scoroId"
                :placeholder="$t('common.scoro')" />
              <tooltip
                v-show="tenantError && tenantError.body.message === 'scoro_not_enabled' || tenantError && tenantError.body.message === 'The scoro id has already been taken.'"
                class="form__validation">{{ tenantError && tenantError.body.message === 'scoro_not_enabled' ?
                  $t('errors.scoro_not_enabled') : $t('errors.duplicated_scoro_id') }}</tooltip>
            </td>
          </tr>
        </table>

        <div v-if="tenantError" class="orange">{{ $t('add_tenant.failed_to_save_tenant') }}</div>

        <div class="form__buttons buttonset">
          <router-link v-if="isNew" :to="{ name: 'tenants' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <router-link v-else :to="{ name: 'tenant', params: { id: $route.params.id } }"
            class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="button" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit(true)">
            {{ $t('common.save') }}
          </button>
        </div>

      </form>

    </div>
  </div>
</template>

<script>
import { parse, format, isValidNumber } from 'libphonenumber-js';
import { mapGetters } from 'vuex';
import 'styles/blocks/details.scss';
import * as mTypes from 'store/mutation-types';
import moment from 'moment';
import EditViewButton from 'common/EditViewButton';
import Autocomplete from 'common/Autocomplete';
import Tooltip from 'common/Tooltip';

export default {
  components: {
    EditViewButton,
    Autocomplete,
    Tooltip,
  },
  watch: {
    $route: 'checkView',
    tenant: 'fetchLandlord',
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
    ...mapGetters({
      landlords: 'landlord/landlords/landlords',
      tenant: 'tenants/tenant/tenant',
      tenantError: 'tenants/tenant/error',
      user: 'user/user/user',
    }),
  },
  data() {
    return {
      form: {},
      landlord: null,
    };
  },
  mounted() {
    this.fetchAllData();
    if (this.isNew) {
      this.$store.commit(`tenants/tenant/${mTypes.CLEAR_STATE}`);
      this.form.createdAt = moment(new Date()).format('DD.MM.YYYY');
    } else {
      this.formatMobileNrForForm();
    }
  },
  created() {
    this.checkView();
    this.createValidators();
  },
  methods: {
    checkView() {
      if (!this.$route.params.id) {
        this.$store.commit(`tenants/tenant/${mTypes.CLEAR_STATE}`);
        this.form = {};
        this.landlord = this.user.data.selectedRole.id;
      } else {
        this.form = this.tenant;
      }
      this.form = this.tenant;
      this.$validator.remove('validPhoneNr');
      this.$validator.extend('validPhoneNr', {
        getMessage: () => 'Please insert valid phone number. Mobile number must include country code.',
        validate: (value) => {
          if (value.trim() === '') {
            return true;
          }
          const parsed = parse(value.trim(), { country: { default: 'EE' } });
          return isValidNumber(parsed);
        },
      });
      if (this.isNew) {
        this.form.createdAt = moment(new Date()).format('DD.MM.YYYY');
      }
    },
    fetchAllData() {
      if (this.$route.params.id) {
        this.fetchTenant();
      } else {
        this.$store.commit(`tenants/tenant/${mTypes.CLEAR_STATE}`);
        this.form = this.tenant;
      }
      if (this.isSuperAdmin()) {
        this.fetchLandlords();
      }
    },
    fetchTenant() {
      this.$store.dispatch('tenants/tenant/fetch',
        { id: this.$route.params.id, user: this.user }).then(() => {
          this.form = this.tenant;
          this.formatMobileNrForForm();
        });
    },
    fetchLandlords() {
      if (this.user.data) {
        this.$store.dispatch('landlord/landlords/list', { user: this.user });
      }
    },
    fetchLandlord() {
      this.$store.dispatch('landlords/landlord/fetch', { id: this.tenant.landlord.id, user: this.user, isSuperAdmin: this.isSuperAdmin() }).then((res) => {
        this.landlord = res.body;
      });
    },
    onSubmit(backToDetails) {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          this.form.partner_id = this.isLandlord() ? this.landlord : this.user.data.selectedRole.id;
          this.parsePhoneBeforeSave();
          this.$store.dispatch('tenants/tenant/saveTenant', { tenant: this.form, user: this.user }).then(() => {
            if (!this.tenantError) {
              this.$store.commit(`landlord/tenants/${mTypes.EDIT_DATA}`, this.form);
              if (backToDetails === true) {
                this.form = {};
                this.$router.push({ name: 'tenant', params: { id: this.tenant.id } });
              }
            }
          }).catch(() => {
            this.$store.commit(`tenants/tenant/${mTypes.DATA_ERROR}`, true);
          });
          this.$validator.clean();
          this.$store.commit(`tenants/tenant/${mTypes.DATA_ERROR}`, null);
        }).catch(() => {
          this.$store.commit(`tenants/tenant/${mTypes.DATA_ERROR}`, true);
        });
    },
    parsePhoneBeforeSave() {
      const parsedPhone = parse(this.form.phoneNumber, { country: { default: 'EE' } });
      this.form.phoneCountry = parsedPhone.country;
      this.form.phone = parsedPhone.phone;
    },
    formatMobileNrForForm() {
      if (this.form.phone) {
        this.form.phoneNumber = format({ country: this.form.phoneCountry, phone: this.form.phone.toString() }, 'International_plaintext');
      } else {
        this.form.phoneNumber = '';
      }
    },
    createValidators() {
      this.createLandlordValidator();
    },
    createLandlordValidator() {
      this.$validator.extend('validLandlord', {
        getMessage: () => 'Tenant must be selected',
        validate: () => this.isSuperAdmin() && (typeof this.landlord !== 'undefined' && this.landlord !== null),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/blocks/details.scss';

.tenant__name input {
  font-size: 24px !important;
  font-family: 'Geogrotesque Md', sans-serif !important;
  padding-top: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenants/AddEditTenantView.vue